module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-3-be9e169fcd090c5707c5320e67ab959e.jpg";